import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_roen_8: FaireProductEntity = {
  token: "legacy_prod_roen-8",
  type: "product",
  name: "La Maison Rose",
  brandName: "ROEN",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/7d898ca08fb70a925d15dcddf5dd3ce9621865277c4b90b9abf7cb1000ad1ff1.webp",
  priceDollars: 18,
  msrpDollars: 36,
  freeShipping: true,
  brandAvatarUrl: "/images/ROEN/Brand%20Page/roen-avatar.webp",
  weight: 0.5,
  dimensions: {
    width: 3,
    height: 4,
    depth: 2,
  },
  brandToken: "catalog_brand_roen",
  description: "Premium candle from ROEN.",
  categoryTokens: ["cat_food-snacks"],
  tags: ["candles", "home fragrance", "premium"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
